import { Injectable, signal } from '@angular/core';

import { firstValueFrom } from 'rxjs';

import { injectTellentIntelligenceHttp } from '@core/tellent-http-legacy';

import { AGENT_ID } from '../tellent-assistant-headers';

@Injectable({ providedIn: 'root' })
export class ToolTitleRegistry {
  private readonly httpApi = injectTellentIntelligenceHttp();

  private readonly titles = signal<Record<string, string>>({});
  public readonly titlesSignal = this.titles.asReadonly();
  private fetchPromise: Promise<void> | null = null;

  public ensureLoaded(): Promise<void> {
    if (this.fetchPromise) return this.fetchPromise;
    this.fetchPromise = this.load().catch(err => {
      console.warn('Failed to load tool titles catalog:', err);
      this.fetchPromise = null;
    });
    return this.fetchPromise;
  }

  private async load(): Promise<void> {
    const body = await firstValueFrom(
      this.httpApi.get<{ titles?: Record<string, string> }>(
        `/assistant/proxy/agents/${AGENT_ID}/tool-titles`,
      ),
    );
    this.titles.set(body.titles ?? {});
  }
}
